import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vShow as _vShow, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8b4b172a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Salvar", -1))
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = { class: "ant-row" }
const _hoisted_4 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_5 = { class: "ant-row" }
const _hoisted_6 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_7 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_8 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_9 = { class: "ant-row" }
const _hoisted_10 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_11 = { class: "ant-col ant-col-xs-24 ant-col-xl-18" }
const _hoisted_12 = { class: "ant-row ss-margin-campos" }
const _hoisted_13 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_14 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_15 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_16 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_17 = { class: "ant-row" }
const _hoisted_18 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_19 = { class: "ant-row" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { class: "ant-col ant-col-xs-24 ant-col-xl-6 ss-btn-flex-end" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "ant-btn ant-btn-secondary ss-acao-destaque-secundaria"
}, " Adicionar ", -1))
const _hoisted_23 = ["rows"]
const _hoisted_24 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_25 = { class: "ant-row" }
const _hoisted_26 = { class: "ant-col ant-col-xs-4 ant-col-xl-4" }
const _hoisted_27 = { class: "ant-col ant-col-xs-3 ant-col-xl-3" }
const _hoisted_28 = { class: "ant-col ant-col-xs-3 ant-col-xl-3" }
const _hoisted_29 = { class: "ant-col ant-col-xs-3 ant-col-xl-3" }
const _hoisted_30 = { class: "ant-col ant-col-xs-3 ant-col-xl-3" }
const _hoisted_31 = { class: "ant-col ant-col-xs-4 ant-col-xl-4" }
const _hoisted_32 = { class: "ant-col ant-col-xs-4 ant-col-xl-4" }
const _hoisted_33 = { class: "ant-row" }
const _hoisted_34 = { class: "ant-col ant-col-xs-4 ant-col-xl-4" }
const _hoisted_35 = { class: "ant-col ant-col-xs-4 ant-col-xl-4" }
const _hoisted_36 = { class: "ant-col ant-col-xs-4 ant-col-xl-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_selecionar_tipo_contato = _resolveComponent("selecionar-tipo-contato")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_campo_cpf_cnpj = _resolveComponent("campo-cpf-cnpj")!
  const _component_card = _resolveComponent("card")!
  const _component_campo_telefone = _resolveComponent("campo-telefone")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!
  const _component_requisicao_modal = _resolveComponent("requisicao-modal")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_modal, {
      visible: _ctx.state.visivel,
      "onUpdate:visible": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.state.visivel) = $event)),
      width: 1000,
      title: "Contato",
      centered: "",
      "wrap-class-name": "ss-modal-cadastros"
    }, {
      closeIcon: _withCtx(() => [
        _createVNode(_component_icone, { nome: "voltar" })
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            type: "button",
            class: "ant-btn ant-btn-lg ant-btn-primary ss-btn-acao-destaque",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.salvarContato && _ctx.salvarContato(...args)))
          }, _hoisted_2)
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_form, { layout: "vertical" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_card, {
                  titulo: "DADOS PRINCIPAIS",
                  class: "ss-margin-campos"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, [
                        _createVNode(_component_a_form_item, {
                          label: "Tipo",
                          class: "ss-margin-campos",
                          rules: [{ required: true }]
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_selecionar_tipo_contato, {
                              relacoes: _ctx.props.relacoes,
                              empresas: _ctx.props.empresas,
                              codigoSelecionado: _ctx.state.pessoaContato.contato.codigoTipoContato,
                              "onUpdate:codigoSelecionado": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.pessoaContato.contato.codigoTipoContato) = $event))
                            }, null, 8, ["relacoes", "empresas", "codigoSelecionado"])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_7, [
                        _createVNode(_component_a_form_item, {
                          label: "Preferência de Contato",
                          class: "ss-margin-campos",
                          rules: [{ required: true }]
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_select, {
                              class: "ss-tamanho-completo",
                              value: _ctx.state.pessoaContato.contato.preferencias.tipoPreferencia,
                              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.pessoaContato.contato.preferencias.tipoPreferencia) = $event)),
                              placeholder: "Selecione",
                              options: _ctx.state.listaTiposPreferenciaContato
                            }, null, 8, ["value", "options"])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_8, [
                        _createVNode(_component_a_form_item, {
                          label: "Nome/Identificação",
                          class: "ss-margin-campos",
                          rules: [{ required: true }]
                        }, {
                          default: _withCtx(() => [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              maxlength: "100",
                              class: "ant-input",
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.pessoaContato.contato.nome) = $event))
                            }, null, 512), [
                              [_vModelText, _ctx.state.pessoaContato.contato.nome]
                            ])
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _createVNode(_component_a_form_item, {
                          label: "Cargo/Ocupação",
                          class: "ss-margin-campos"
                        }, {
                          default: _withCtx(() => [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              maxlength: "250",
                              class: "ant-input",
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.pessoaContato.contato.cargo) = $event))
                            }, null, 512), [
                              [_vModelText, _ctx.state.pessoaContato.contato.cargo]
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_11, [
                        _createVNode(_component_a_form_item, {
                          label: "E-mail",
                          class: "ss-margin-campos"
                        }, {
                          default: _withCtx(() => [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              maxlength: "250",
                              class: "ant-input",
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.pessoaContato.contato.email) = $event))
                            }, null, 512), [
                              [_vModelText, _ctx.state.pessoaContato.contato.email]
                            ])
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _createVNode(_component_a_checkbox, {
                          checked: _ctx.state.pessoaContato.contato.permissao.consultarXml,
                          "onUpdate:checked": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.pessoaContato.contato.permissao.consultarXml) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Autorizar consulta XML")
                          ]),
                          _: 1
                        }, 8, ["checked"])
                      ]),
                      _createElementVNode("div", _hoisted_14, [
                        _createVNode(_component_a_checkbox, {
                          checked: _ctx.state.pessoaContato.contato.permissao.receberNfe,
                          "onUpdate:checked": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.pessoaContato.contato.permissao.receberNfe) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Receber NF-e")
                          ]),
                          _: 1
                        }, 8, ["checked"])
                      ]),
                      _createElementVNode("div", _hoisted_15, [
                        _createVNode(_component_a_checkbox, {
                          checked: _ctx.state.pessoaContato.contato.permissao.receberNfse,
                          "onUpdate:checked": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.pessoaContato.contato.permissao.receberNfse) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Receber NFS-e")
                          ]),
                          _: 1
                        }, 8, ["checked"])
                      ]),
                      _createElementVNode("div", _hoisted_16, [
                        _createVNode(_component_a_checkbox, {
                          checked: _ctx.state.pessoaContato.contato.permissao.receberCobranca,
                          "onUpdate:checked": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.pessoaContato.contato.permissao.receberCobranca) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Receber cobrança")
                          ]),
                          _: 1
                        }, 8, ["checked"])
                      ])
                    ]),
                    _withDirectives(_createElementVNode("div", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        _createVNode(_component_a_form_item, {
                          label: "CPF/CPNJ",
                          class: "ss-margin-campos"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_campo_cpf_cnpj, {
                              valor: _ctx.state.pessoaContato.contato.permissao.cpfCnpjAutorizacao,
                              "onUpdate:valor": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.pessoaContato.contato.permissao.cpfCnpjAutorizacao) = $event))
                            }, null, 8, ["valor"])
                          ]),
                          _: 1
                        })
                      ])
                    ], 512), [
                      [_vShow, _ctx.state.pessoaContato.contato.permissao.consultarXml]
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_card, {
                  titulo: "TELEFONES",
                  class: "ss-margin-campos"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_19, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.pessoaContato.contato.telefones, (itemTelefone) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "ant-col ant-col-xs-24 ant-col-xl-6",
                          key: itemTelefone.codigo
                        }, [
                          _createVNode(_component_a_form_item, {
                            label: _ctx.obterDescricaoTipoTelefone(itemTelefone.tipoTelefone),
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("a", {
                                title: "Remover telefone",
                                onClick: ($event: any) => (_ctx.removerTelefone(itemTelefone.codigo)),
                                class: "excluir ss-apresentar-superior-direito"
                              }, [
                                _createVNode(_component_icone, { nome: "excluir" })
                              ], 8, _hoisted_20),
                              _createVNode(_component_campo_telefone, {
                                valor: itemTelefone.telefone,
                                "onUpdate:valor": ($event: any) => ((itemTelefone.telefone) = $event),
                                icone: _ctx.obterIconeTipoTelefone(itemTelefone.tipoTelefone)
                              }, null, 8, ["valor", "onUpdate:valor", "icone"])
                            ]),
                            _: 2
                          }, 1032, ["label"])
                        ]))
                      }), 128)),
                      _createElementVNode("div", _hoisted_21, [
                        _createVNode(_component_a_dropdown, null, {
                          overlay: _withCtx(() => [
                            _createVNode(_component_a_menu, null, {
                              default: _withCtx(() => [
                                (_openBlock(), _createBlock(_component_a_menu_item, {
                                  onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.adicionarTelefone(_ctx.ETipoTelefone.Celular))),
                                  key: _ctx.ETipoTelefone.Celular
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Celular")
                                  ]),
                                  _: 1
                                })),
                                (_openBlock(), _createBlock(_component_a_menu_item, {
                                  onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.adicionarTelefone(_ctx.ETipoTelefone.Fixo))),
                                  key: _ctx.ETipoTelefone.Fixo
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Fixo")
                                  ]),
                                  _: 1
                                })),
                                (_openBlock(), _createBlock(_component_a_menu_item, {
                                  onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.adicionarTelefone(_ctx.ETipoTelefone.WhatsApp))),
                                  key: _ctx.ETipoTelefone.WhatsApp
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("WhatsApp")
                                  ]),
                                  _: 1
                                })),
                                (_openBlock(), _createBlock(_component_a_menu_item, {
                                  onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.adicionarTelefone(_ctx.ETipoTelefone.Telegram))),
                                  key: _ctx.ETipoTelefone.Telegram
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Telegram")
                                  ]),
                                  _: 1
                                }))
                              ]),
                              _: 1
                            })
                          ]),
                          default: _withCtx(() => [
                            _hoisted_22
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_card, {
                  titulo: "OBSERVAÇÕES",
                  class: "ss-margin-campos"
                }, {
                  default: _withCtx(() => [
                    _withDirectives(_createElementVNode("textarea", {
                      placeholder: "Digite suas observações aqui",
                      rows: _ctx.state.pessoaContato.contato.permissao.consultarXml?3:5,
                      class: "ant-input",
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.state.pessoaContato.contato.observacoes) = $event))
                    }, null, 8, _hoisted_23), [
                      [_vModelText, _ctx.state.pessoaContato.contato.observacoes]
                    ])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createVNode(_component_card, {
                  titulo: "DIAS PARA CONTATO",
                  class: "ss-margin-campos"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("div", _hoisted_26, [
                        _createVNode(_component_a_checkbox, {
                          checked: _ctx.state.pessoaContato.contato.preferencias.segunda,
                          "onUpdate:checked": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.state.pessoaContato.contato.preferencias.segunda) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Segunda")
                          ]),
                          _: 1
                        }, 8, ["checked"])
                      ]),
                      _createElementVNode("div", _hoisted_27, [
                        _createVNode(_component_a_checkbox, {
                          checked: _ctx.state.pessoaContato.contato.preferencias.terca,
                          "onUpdate:checked": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.state.pessoaContato.contato.preferencias.terca) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Terça")
                          ]),
                          _: 1
                        }, 8, ["checked"])
                      ]),
                      _createElementVNode("div", _hoisted_28, [
                        _createVNode(_component_a_checkbox, {
                          checked: _ctx.state.pessoaContato.contato.preferencias.quarta,
                          "onUpdate:checked": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.state.pessoaContato.contato.preferencias.quarta) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Quarta")
                          ]),
                          _: 1
                        }, 8, ["checked"])
                      ]),
                      _createElementVNode("div", _hoisted_29, [
                        _createVNode(_component_a_checkbox, {
                          checked: _ctx.state.pessoaContato.contato.preferencias.quinta,
                          "onUpdate:checked": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.state.pessoaContato.contato.preferencias.quinta) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Quinta")
                          ]),
                          _: 1
                        }, 8, ["checked"])
                      ]),
                      _createElementVNode("div", _hoisted_30, [
                        _createVNode(_component_a_checkbox, {
                          checked: _ctx.state.pessoaContato.contato.preferencias.sexta,
                          "onUpdate:checked": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.state.pessoaContato.contato.preferencias.sexta) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Sexta")
                          ]),
                          _: 1
                        }, 8, ["checked"])
                      ]),
                      _createElementVNode("div", _hoisted_31, [
                        _createVNode(_component_a_checkbox, {
                          checked: _ctx.state.pessoaContato.contato.preferencias.sabado,
                          "onUpdate:checked": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.state.pessoaContato.contato.preferencias.sabado) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Sábado")
                          ]),
                          _: 1
                        }, 8, ["checked"])
                      ]),
                      _createElementVNode("div", _hoisted_32, [
                        _createVNode(_component_a_checkbox, {
                          checked: _ctx.state.pessoaContato.contato.preferencias.domingo,
                          "onUpdate:checked": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.state.pessoaContato.contato.preferencias.domingo) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Domingo")
                          ]),
                          _: 1
                        }, 8, ["checked"])
                      ])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_card, {
                  titulo: "TURNO CONTATO",
                  class: "ss-margin-campos"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_33, [
                      _createElementVNode("div", _hoisted_34, [
                        _createVNode(_component_a_checkbox, {
                          checked: _ctx.state.pessoaContato.contato.preferencias.manha,
                          "onUpdate:checked": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.state.pessoaContato.contato.preferencias.manha) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Manhã")
                          ]),
                          _: 1
                        }, 8, ["checked"])
                      ]),
                      _createElementVNode("div", _hoisted_35, [
                        _createVNode(_component_a_checkbox, {
                          checked: _ctx.state.pessoaContato.contato.preferencias.tarde,
                          "onUpdate:checked": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.state.pessoaContato.contato.preferencias.tarde) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Tarde")
                          ]),
                          _: 1
                        }, 8, ["checked"])
                      ]),
                      _createElementVNode("div", _hoisted_36, [
                        _createVNode(_component_a_checkbox, {
                          checked: _ctx.state.pessoaContato.contato.preferencias.noite,
                          "onUpdate:checked": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.state.pessoaContato.contato.preferencias.noite) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Noite")
                          ]),
                          _: 1
                        }, 8, ["checked"])
                      ])
                    ])
                  ]),
                  _: 1
                })
              ])
            ]),
            _createVNode(_component_requisicao_modal, {
              visivel: _ctx.modalBase.exibirRequisicaoModal,
              "onUpdate:visivel": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.modalBase.exibirRequisicaoModal) = $event)),
              retornoRequisicao: _ctx.modalBase.retornoRequisicao
            }, null, 8, ["visivel", "retornoRequisicao"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}